module.exports = __webpack_public_path__ + "img/75.18f15025.png";